import { api } from '@/lib/api';

interface User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
}

interface PaginatedUsers {
  data: User[];
  total: number;
  page: number;
  limit: number;
}

/**
 * Service pour récupérer les utilisateurs du tenant
 */
export const usersService = {
  /**
   * Récupère tous les utilisateurs du tenant
   */
  async getAll(): Promise<{ id: number; name: string; email: string }[]> {
    const response = await api.get<PaginatedUsers>('/users', {
      params: { limit: 100 },
    });
    return response.data.data.map((user) => ({
      id: user.id,
      name: `${user.firstName} ${user.lastName}`,
      email: user.email,
    }));
  },
};
